const LF = /\r?\n/;
const EMPTY_LINE = /^\s*$/;
const SPACE = /\s/;
const LF_AFFIX = /(^\r?\n)|(\r?\n$)/g;

/**
 * Tag function used to aid in the construction of code blocks.
 */
export function code(strings: TemplateStringsArray, ...values: any[]): string {
  const minIndent = Math.min(
    ...strings.join("").split(LF).filter(isNotEmpty).map(indentWidth),
  );

  let result = "";
  for (let i = 0; i < values.length; ++i) {
    const trimmedString = trimNoninitialLines(strings[i], minIndent);
    result += trimmedString;
    result += indentNoninitialLines(
      String(values[i]),
      indentWidth(trimmedString.split(LF).at(-1)!),
    );
  }
  result += trimNoninitialLines(strings.at(-1)!, minIndent);
  return result.replace(LF_AFFIX, "");
}

function isNotEmpty(line: string): boolean {
  return !EMPTY_LINE.test(line);
}

function indentWidth(line: string): number {
  let width = 0;
  for (const c of line) {
    if (!SPACE.test(c)) {
      break;
    }
    ++width;
  }
  return width;
}

function indentNoninitialLines(str: string, indentWidth: number): string {
  const lines = str.split(LF);
  const resultLines: string[] = [lines[0]];
  for (let i = 1; i < lines.length; ++i) {
    const line = lines[i];
    resultLines.push(line && " ".repeat(indentWidth) + line);
  }
  return resultLines.join("\n");
}

function trimNoninitialLines(str: string, indentWidth: number): string {
  const lines = str.split(LF);
  const resultLines: string[] = [lines[0]];
  for (let i = 1; i < lines.length; ++i) {
    resultLines.push(lines[i].slice(indentWidth));
  }
  return resultLines.join("\n");
}
